import { defineStore } from 'pinia';

export const useFilterStore = defineStore('filter', {
  state: () => ({
    // Map of module-specific filters
    // Format: { 'society_list': { search: '', options: {}, page: 1 } }
    filters: {},
    lastModule: null
  }),

  actions: {
    /**
     * Update filter for a module. 
     * If the module is different from the last visited one, others are cleared.
     */
    updateFilter(moduleName, data) {
      // If navigating to a brand new module (not detail/edit sub-pages), clear previous
      if (this.lastModule && this.lastModule !== moduleName) {
        this.filters = {};
      }

      this.lastModule = moduleName;
      this.filters[moduleName] = {
        ...(this.filters[moduleName] || {}),
        ...data
      };
    },

    getFilter(moduleName) {
      return this.filters[moduleName] || null;
    },

    clearAll() {
      this.filters = {};
      this.lastModule = null;
    }
  }
});
